import im from 'immutable';
import { scheduleReducer } from 'app/reducers';

export default function setupReducer(Actions, Schema, createReducer) {
  const Identity = im.Map({});
  const reducer = createReducer(Actions, Schema, Identity);
  scheduleReducer(Schema.name.toLowerCase(), reducer);
}
